import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

// Components //
import Icon from 'components/Icons';

const animation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Root = styled(Icon)`
  margin-bottom: 16px;
  animation: ${ animation } ${ ({ speed }) => `${ speed }ms`} linear infinite;
`;

const LoadingSpinner = props => {
  return (
    <Root
      {...props}
      viewBox="0 0 32 32"
    >
      <g>
        <defs>
          <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="loader_gradient">
            <stop stopColor="#0169F6" stopOpacity="0" offset="0%"></stop>
            <stop stopColor="#006CFF" offset="100%"></stop>
          </linearGradient>
        </defs>
        <path
          d="M2,24.3213837 L3.66427674,23.2118659 C5.99542297,26.7016346 9.97034324,29 14.4820755,29 C21.6617773,29 27.4820755,23.1797017 27.4820755,16 C27.4820755,8.82029825 21.6617773,3 14.4820755,3 L14.4820755,1 C22.7663468,1 29.4820755,7.71572875 29.4820755,16 C29.4820755,24.2842712 22.7663468,31 14.4820755,31 C9.27623058,31 4.68978411,28.3480399 2,24.3213837 Z"
          fill="url(#loader_gradient)"
        />
      </g>
    </Root>
  );
}

LoadingSpinner.propTypes = {
  speed: PropTypes.number,
};

LoadingSpinner.defaultProps = {
  speed: 4000
}

export default LoadingSpinner;
